function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 12.6c-.24 0-.46-.11-.6-.3L8.9 8.97a.752.752 0 01-.07-.79c.13-.26.39-.41.67-.41h5c.28 0 .54.16.67.41.13.25.1.56-.07.79l-2.5 3.33c-.14.19-.36.3-.6.3zm-1-3.33l1 1.33 1-1.33h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12S6.07 1.25 12 1.25 22.75 6.07 22.75 12 17.93 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 17.75c-.24 0-.47-.12-.61-.31l-5-7a.76.76 0 01.17-1.05.76.76 0 011.05.17L12 15.71l4.39-6.15c.24-.34.71-.42 1.05-.17.34.24.42.71.17 1.05l-5 7c-.14.19-.37.31-.61.31z"
})));